import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { getDecryptedUserFromCookie } from './utils/getCookie';
import { toast } from 'react-toastify';
import ItemTable from './ReceiptUtils/ItemTable';
import { PanelBottomClose, PanelLeftClose, PanelTopClose, PanelTopCloseIcon, X } from 'lucide-react';
import { decryptToken } from './utils/getToken';

const ReceiptModal = ({ isOpen, setIsOpen, editData = null, fetchReceipts, fetchInvoices }) => {
  const [formData, setFormData] = useState({
    customerName: '',
    invoiceNumber: '',
    amount: '',
    receiptDate: '',
    customerId: '',
    order_number: "",
    invoice_Number: "",
    sendMail: true,
    invoice_date: ""
  });
  const [taxAmountTotal, setTaxAmountTotal] = useState()
  const [discountAmountTotal, setDisountamountTotal] = useState()
  const url = process.env.REACT_APP_LINK;
  const [customerOptions, setCustomerOptions] = useState([]);
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [amountError, setAmountError] = useState('');
  const [sendWhatsapp, setSendWhatsapp] = useState(false);
  const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
  const [invoiceDataget, setInvoiceData] = useState([])
  const [openInvoice, setOpenInvoice] = useState(false);
  const [items, setItems] = useState([
    {
      id: 1, item: null, quantity: "", rate: "", discount: "", tax: "", discount_amount: 0, hsn: "",
      tax_amount: 0
    },
  ]);
  const token = decryptToken("accessToken") || ""
  const invoicePrefix = "INVE";
  const [shipping, setShipping] = useState(0);
  const [subtotal, setSubtotal] = useState("");
  const [advance_payment, setAdvancePayment] = useState(0);
  const [itemsOptions, setItemsOptions] = useState([]);
  const [load, setLoad] = useState(false);


  const [selectedInvoice, setSelectedInvoice] = useState(null); // store selected invoice
  const [selectedInvoiceMain, setSelectedInvoiceMain] = useState(null); // store selected invoice

  useEffect(() => {
    if (!isOpen) return;

    const fetchCustomers = async () => {
      try {
        const user = getDecryptedUserFromCookie("gta_mainstateuser");
        const res = await fetch(`${url}/api/customer/all/${user.main_id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });
        const data = await res.json();

        const formatted = data.map((cust) => ({
          value: cust.cust_ID,
          label: `${cust.cust_ID} - ${cust.customerName}`,
          name: cust.customerName
        }));
        setCustomerOptions(formatted);


        // 🛠 Set form data after setting options
        if (editData) {
          setFormData({
            customerName: editData.customerName || '',
            invoiceNumber: editData.invoiceNumber || '',
            amount: editData.amount || '',
            receiptDate: editData.receiptDate || '',
            customerId: editData.customerId || '',
            sendMail: editData.sendMail ?? true,
          });
          await fetchInvoicesByCustomer(editData.customerId);
          await fetchInvoicesForAllCustomer(editData.customerId);



        } else {
          setFormData({
            customerName: '',
            invoiceNumber: '',
            amount: '',
            receiptDate: '',
            customerId: '',
            sendMail: true,
          });
        }
      } catch (err) {
        console.error('Failed to fetch customers:', err);
      }
    };

    fetchCustomers();
  }, [isOpen, editData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    if (load) return;
    setLoad(true);
    if (openInvoice) {
      const user = getDecryptedUserFromCookie("gta_mainstateuser");
      const today = new Date().toLocaleDateString('en-CA');
      const payloadMain = {
        ...formData,
        amount: subtotal,
        invoice_number: `${formData.invoice_Number}`,
        invoiceNumber: `${formData.invoice_Number}`,
        subtotal: subtotal,
        openInvoice: openInvoice,
        items: items.map(row => ({
          id: row.id,
          item: row.item, // full object
          hsn: row.hsn,
          quantity: row.quantity,
          rate: row.rate,
          discount: row.discount,
          tax: row.tax,
          amount: (
            (row.quantity || 0) *
            (row.rate || 0) *
            (1 - (row.discount || 0) / 100) *
            (1 + (row.tax || 0) / 100)
          ).toFixed(2),
        })),
        tax: taxAmountTotal,
        grand_total: subtotal,
        advance_payment: subtotal,
        discount_amount: discountAmountTotal,
        user_id: user.main_id,
        user_name: user.full_name || "Admin",
        main_id: user.main_id,
        due_date: today,
        terms: "custom"
      }

      try {
        const response = await fetch(`${url}/receipt/invoice-plus-reciept`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payloadMain)
        })
        const res = await response.json();
        if (response.ok) {
          toast.success(`Receipt created successfully!`);
          setIsOpen(false);
          fetchReceipts();
          fetchInvoices();
        } else if (response.status === 403) {
          // Show plan limit exceeded message
          alert(res.message || 'You have reached your receipt submission limit based on your plan.');
        } else {
          alert(res.message || 'Failed to process receipt');
        }
      } catch (error) {
        console.error(error);
        alert('An error occurred while submitting the receipt.');
      } finally {
        setLoad(false)
      }
    } else {
      try {
        const user = getDecryptedUserFromCookie("gta_mainstateuser");
        const payload = {
          ...formData,
          user_id: user.main_id,
          user_name: user.full_name || "Admin",
          main_id: user.main_id
          // sendWhatsapp: sendWhatsapp,
        };

        const urlmain = editData
          ? `${url}/receipt/${editData.id}`
          : `${url}/receipt`;
        const method = editData ? 'PUT' : 'POST';

        const response = await fetch(urlmain, {
          method,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        });

        const result = await response.json();

        if (response.ok) {
          toast(`Receipt ${editData ? 'updated' : 'created'} successfully!`);
          setIsOpen(false);
          fetchReceipts();
        } else if (response.status === 403) {
          // Show plan limit exceeded message
          alert(result.message || 'You have reached your receipt submission limit based on your plan.');
        } else {
          alert(result.message || 'Failed to process receipt');
        }
      } catch (err) {
        console.error('Error submitting receipt:', err);
        alert('An error occurred while submitting the receipt.');
      } finally {
        setLoad(false);
      }
    }
  };


  const fetchInvoicesForAllCustomer = async (customerId) => {
    try {
      const response = await fetch(`${url}/newinvoice/getinvoice/by-customerId/${customerId}/${isLoggedIn.main_id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      const data = await response.json();
      const invoiceDataMain = data.customer;
      const options = invoiceDataMain.map((inv) => ({
        value: inv.invoice_number,
        label: `${inv.customer_name}-${inv.invoice_number}`,
        pending: inv.pending || 0, // adjust field name if needed
        fullData: inv
      }))
      setInvoiceData(options)
    } catch (error) {
      console.error(error)
    }
  }


  const fetchInvoicesByCustomer = async (customerId) => {
    try {
      const res = await fetch(
        `${url}/newinvoice/by-customer/${customerId}/${isLoggedIn.main_id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );

      const data = await res.json();

      // ✅ normalize response
      const invoices = Array.isArray(data)
        ? data
        : Array.isArray(data.invoices)
          ? data.invoices
          : Array.isArray(data.customer)
            ? data.customer
            : [];

      const options = invoices.map((inv) => ({
        value: inv.invoice_number,
        label: inv.invoice_number,
        invoice: inv
      }));

      setInvoiceOptions(options);
    } catch (err) {
      console.error("Error fetching invoices:", err);
      setInvoiceOptions([]);
    }
  };


  useEffect(() => {
    if (formData.invoiceNumber && invoiceDataget.length > 0) {
      const found = invoiceDataget.find(
        (inv) => inv.value === formData.invoiceNumber
      );
      setSelectedInvoiceMain(found || null);
    }
  }, [formData.invoiceNumber, invoiceDataget]);


  const fetchDatareciept = async () => {
    try {
      const [invoiceRes, orderRes] = await Promise.all([
        fetch(`${url}/newinvoice/next-number/${isLoggedIn.main_id}`),
        fetch(`${url}/newinvoice/next-order-number/${isLoggedIn.main_id}`)
      ]);
      const invoiceData = await invoiceRes.json();
      const orderData = await orderRes.json();
      const today = new Date().toLocaleDateString('en-CA');
      // setInvoiceNumberNumeric(invoiceData.invoice_number.replace("INVE", ""));
      setFormData((prev) => ({
        ...prev,
        invoice_Number: invoiceData.invoice_number,
        order_number: orderData.order_number,
        invoice_date: today
      }));
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetchDatareciept();
  }, [])

  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
      <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="oms-modal-title">
          {editData ? 'Edit Receipt' : 'Generate Receipt'}
        </h2>
        <form className="oms-modal-form" onSubmit={handleSubmit}>
          <div className="oms-form-group">
            <label className="oms-form-label">Receipt Date</label>
            <input
              type="date"
              name="receiptDate"
              value={formData.receiptDate}
              onChange={handleChange}
              required
            />
          </div>
          <div className="oms-form-group">
            <label className="oms-form-label">Customer Name</label>
            <Select
              name="customerName"
              value={customerOptions.find((opt) => String(opt.value) === String(formData.customerId)) || null}
              onChange={(selected) => {
                if (!selected) {
                  // When cleared
                  setFormData((prev) => ({
                    ...prev,
                    customerName: '',
                    customerId: '',
                    invoiceNumber: ''
                  }));
                  setInvoiceOptions([]);
                  setInvoiceData([]);
                  return;
                }
                setFormData((prev) => ({
                  ...prev,
                  customerName: selected.label,
                  customerId: selected.value,
                  invoiceNumber: '' // reset invoice on customer change
                }));
                fetchInvoicesByCustomer(selected.value);
                fetchInvoicesForAllCustomer(selected.value);
              }}

              options={customerOptions}
              placeholder="Select customer"
              isClearable
            />
          </div>


          {
            !openInvoice ? <div className="oms-form-group">
              <div className='displayflexreciept-invoicenumber'>
                <label className="oms-form-label">Invoice Number</label>
                <p onClick={() => {
                  setOpenInvoice(true)
                  setSelectedInvoiceMain(null)
                  fetchDatareciept()
                  setFormData((prev) => ({
                    ...prev,
                    amount: "",
                    invoiceNumber: ''
                  }));

                }}>New Invoice</p>
              </div>
              <Select
                type="text"
                name="invoiceNumber"
                value={invoiceDataget.find((opt) => opt.value === formData.invoiceNumber) || null}
                onChange={(selected) => {
                  if (!selected) {
                    // When cleared
                    setFormData((prev) => ({
                      ...prev,
                      invoiceNumber: ''
                    }));
                    fetchInvoicesForAllCustomer(formData.customerId);
                    setSelectedInvoiceMain(null);
                    return;
                  }
                  setFormData((prev) => ({
                    ...prev,
                    invoiceNumber: selected.value,

                  }));
                  setSelectedInvoice(selected);
                  setSelectedInvoiceMain(selected);
                }}
                options={invoiceDataget}
                placeholder="Enter invoice number"
                isClearable
              />
            </div> : null
          }

          {
            openInvoice ?
              <div>
                <p onClick={() => {
                  setOpenInvoice(false)
                  setSubtotal("")
                  setFormData((prev) => ({
                    ...prev,
                    amount: "",
                  }));
                  setItems([
                    {
                      id: Date.now(), item: null, quantity: "1", rate: "", discount: "", tax: "", amount: 0, discount_amount: 0,
                      tax_amount: 0, hsn: ""
                    },
                  ]);
                }} className='invoiceeightclosebtn-receipt'>Close</p>
                <ItemTable

                  items={items} setItems={setItems} subtotal={subtotal} setSubtotal={setSubtotal} itemsOptions={itemsOptions} setItemsOptions={setItemsOptions}
                  taxAmountTotal={taxAmountTotal}
                  setTaxAmountTotal={setTaxAmountTotal}
                  discountAmountTotal={discountAmountTotal}
                  setDisountamountTotal={setDisountamountTotal}
                />
              </div> : null
          }
          <div className="oms-form-group">
            <label className="oms-form-label">
              {selectedInvoiceMain?.pending != null
                ? `Amount (Balance: ₹${parseFloat(selectedInvoiceMain.pending).toFixed(2)})`
                : 'Amount'}
            </label>
            <input
              type="number"
              name="amount"
              value={formData.amount || subtotal}
              placeholder="Enter amount"
              onChange={(e) => {
                const enteredAmount = parseFloat(e.target.value) || "";
                setFormData((prev) => ({ ...prev, amount: e.target.value }));

                if (selectedInvoiceMain && enteredAmount > parseFloat(selectedInvoiceMain.pending)) {
                  setAmountError(`Amount cannot exceed pending amount ₹${selectedInvoiceMain.pending}`);
                } else {
                  setAmountError('');
                }
              }}
              onWheel={(e) => e.target.blur()}
              required
            />
            {selectedInvoiceMain?.pending != null && (
              <p className={`maininvoice-oms-${amountError ? 'red' : 'green'}`} >
                Remaining Balance: ₹
                {(() => {
                  const pending = parseFloat(selectedInvoiceMain.pending);
                  const entered = parseFloat(formData.amount) || 0;
                  const remaining = pending - entered;
                  return remaining >= 0 ? remaining.toFixed(2) : '0.00';
                })()}
              </p>
            )}
            {amountError && <p style={{ color: 'red', marginTop: '4px' }}>{amountError}</p>}
          </div>





          {/* <div className="oms-form-group" style={{ marginTop: "1rem" }}>
            <input
              type="checkbox"
              id="sendWhatsapp"
              checked={sendWhatsapp}
              onChange={() => setSendWhatsapp(!sendWhatsapp)}
            />
            <label htmlFor="sendWhatsapp" style={{ marginLeft: "8px" }}>
              Send invoice to customer via WhatsApp
            </label>
          </div> */}
          {/* <div className="oms-form-group">

            <br />
            <label>
              <input
                type="checkbox"
                name="sendMail"
                checked={formData.sendMail}
                onChange={handleChange}
              />
              &nbsp;Send Mail
            </label>
          </div> */}
          {/* <div className="oms-form-actions">
            <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
            <button type="submit">{editData ? 'Update' : 'Generate'} </button>
          </div> */}

          <div className="oms-form-actions">
            <button
              type="button"
              onClick={() => setIsOpen(false)}
              disabled={load}
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={load}
            >
              {load
                ? editData
                  ? "Updating..."
                  : "Generating..."
                : editData
                  ? "Update"
                  : "Generate"}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default ReceiptModal;
